import {ChangeDateFormat} from "../../../Common/Helpers/ChangeDateFormat";
import i18n from "i18next";

class AdminResponseOrgModel {
    constructor({
                    id = '',
                    visualId = '',
                    name = '',
                    parentId = '',
                    parentName = '',
                    type = '',
                    costPlace = '',
                    createdAt = ChangeDateFormat('dateTime', new Date()),
                } = {}) {
        this.id = id;
        this.visualId = visualId;
        this.name = name;
        this.parentId = parentId;
        this.parentName = parentName;
        this.type = type;
        this.costPlace = costPlace;
        this.createdAt = createdAt ? ChangeDateFormat('dateTime', createdAt) : '' ;
    }

    static getAttributes(filter = null, validationSchema = null) {

        const attributes =  {
            id :{
                'label': 'Id',
                'sortable': true,
                'sortField': 'id',
                'value': (item) => item.id || "",
            },
            visualId :{
                'label': i18n.t('modelLabel.id'),
                'sortable': true,
                'sortField': 'visualId',
                'value': (item) => item.visualId || "",
            },
            name: {
                'label': i18n.t('modelLabel.orgName'),
                'sortable': true,
                'sortField': 'name',
                'value': (item) => item.name || "",
            },
            parentId:{
                'label': i18n.t('modelLabel.parentId'),
                'sortable': true,
                'sortField': 'parentId',
                'value': (item) => item.parentId || "",
            },
            parentName: {
                'label': i18n.t('modelLabel.parentName'),
                'sortable': true,
                'sortField': 'parentName',
                'value': (item) => item.parentName || "",
            },
            type: {
                'label': i18n.t('modelLabel.type'),
                'sortable': true,
                'sortField': 'type',
                'value': (item) => item.type || "",
            },
            costPlace: {
                'label': i18n.t('modelLabel.costPlace'),
                'sortable': true,
                'sortField': 'costPlace',
                'value': (item) => item.costPlace || "",
            },
            createdAt: {
                'label': i18n.t('modelLabel.createdAt'),
                'sortable': true,
                'sortField': 'createdAt',
                'value': (item) => item.createdAt ? ChangeDateFormat('dateTime', item.createdAt) : 'not set'|| "not set",
                'type': 'dateTime' ,
            }
        };

        return attributes;
    }
}

export default AdminResponseOrgModel;